// src/store/authStore.ts
import { create } from 'zustand';
import {
  getLocalStorageValue,
  removeLocalStorageValue,
} from '../../utils/local-storage.ts';
import { isAccessTokenExpired } from '../../utils/auth.ts';

const resolveAuthStatus = (): boolean => {
  const stored = getLocalStorageValue('userAccessToken');
  const accessToken = stored?.accessToken;

  if (!accessToken) {
    return false;
  }

  if (isAccessTokenExpired(accessToken)) {
    removeLocalStorageValue('userAccessToken');
    return false;
  }

  return true;
};

interface AuthState {
  isAuthenticated: boolean;
  checkAuthStatus: () => boolean;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: resolveAuthStatus(),
  checkAuthStatus: () => {
    const isAuthenticated = resolveAuthStatus();
    set({ isAuthenticated });
    return isAuthenticated;
  },
}));
